import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Icon from 'components/icon/icon'

import {
	openModal,
	getProgressUpdates
} from 'state/actions'

import { 
	doSort,
	getSessionSeconds,
	getPrimaryColumnValue
} from 'utils'

import Button from 'components/button/button'

class ProgressUpdate extends Component {
	state = {
		isLoading: false
	}

	componentWillMount = _ => {
		const {
			project,
			getProgressUpdates
		} = this.props

		if(project){
			this.setState({
				isLoading: true
			})

			getProgressUpdates(project.id, _ => {
				this.setState({
					isLoading: false
				})
			})
		}
	}

	generateUpdateData = _ => {
		const {
			project,
			allTasks,
			allMilestones,
			allSessions
		} = this.props

		const allProjectTasks = []

		project && project.milestones.forEach(milestoneId => {
			const milestoneObject = allMilestones[milestoneId]

			milestoneObject && milestoneObject.tasks.forEach(taskId => {
				const task = allTasks[taskId]

				if(task){
					allProjectTasks.push(task)
				}
			})
		})

		let completedCount = 0
		let allTasksCount = allProjectTasks.length
		let overdueCount = 0
		let secondsEstimated = 0
		let secondsTracked = 0

		allProjectTasks.forEach(task => {
			const statusId = getPrimaryColumnValue('status', task, project)
			const taskDates = getPrimaryColumnValue('date', task, project)

			if(statusId === 3){
				completedCount++
			}else if(taskDates.end && moment(taskDates.end).isBefore(moment().startOf('day'))){
				overdueCount++
			}

			if(task.estimated_minutes){
				secondsEstimated += (task.estimated_minutes * 60)
			}

			task.sessions && task.sessions.forEach(sessionId => {
				const session = allSessions[sessionId]

				if(!session){
					return 
				}
				
				const sessionSeconds = getSessionSeconds(session)

				if(sessionSeconds){
					secondsTracked += sessionSeconds
				}
			})
		})

		return {
			totalTasks: allProjectTasks.length,
			totalComplete: completedCount,
			completedPercent: Math.round((completedCount/allTasksCount)*100),
			overdueCount,
			hoursTracked: Math.round(secondsTracked/3600),
			hoursEstimated: Math.round(secondsEstimated/3600),
			projectId: project.id
		}
	}

	deleteUpdate = progressUpdate => {
		this.props.openModal('delete','progress_update',progressUpdate)
	}

	openUpdateModal = (progressUpdate, isView) => {
		const updateData = progressUpdate ? progressUpdate : this.generateUpdateData()
		
		this.props.openModal(isView ? 'view' : 'add','update', updateData)
	}

	render() {
		const {
			project,
			allProgressUpdates
		} = this.props

		let progressUpdates = [] 
		
		project.progress_updates && project.progress_updates.forEach(progressUpdateId => {
			const progressUpdate = allProgressUpdates[progressUpdateId]

			if(progressUpdate && !progressUpdate.deleted_ats){
				progressUpdates.push(progressUpdate)
			}
		})

		progressUpdates = doSort(progressUpdates, 'number', 'id', true)

		return (
			<div className="widget box progress-update">
				<h3>
					Progress updates
					<div className="header-tab-controls">
						<button 
							className="active header-button high"
							onClick={_ => {this.openUpdateModal(null, false)}}
						>
							<span>
								Add update
							</span>
						</button>
					</div>
				</h3>
				<div>
					<ul className="big-task-list headertab-list no-padding">
						{ (progressUpdates && progressUpdates.length) ? 
							progressUpdates.map(progressUpdate => {

								const modalData = {
									completedPercent: Math.round((progressUpdate.completed_task_count/progressUpdate.total_task_count)*100),
									hoursEstimated: progressUpdate.hours_estimated,
									hoursTracked: progressUpdate.hours_tracked,
									overdueCount: progressUpdate.overdue_task_count,
									created_at: progressUpdate.created_at,
									text: progressUpdate.text
								}

								return (
									<li 
										className="list-item" key={progressUpdate.id}
										onClick={_ => {this.openUpdateModal(modalData, true)}}
									>
										<div className="list-item-content">
											<h4 className="date">
												<em>
													{ moment(progressUpdate.created_at).format('Do MMMM, h:mm a')  }
												</em>
												<span>
													{ progressUpdate.text }
												</span>
												<div 
													className="message-controls"
													onClick={e => e.stopPropagation()}
												>
													<button
														onClick={_ => {this.deleteUpdate(progressUpdate)}}
													>
														<Icon name="fe-trash-2" />
													</button>
												</div>
											</h4>
										</div>
									</li>
								)
							})
							:
							<li className="list-item empty-banner">
								<h2>
									No progress updates.
								</h2>
								<p>
									Add progress updates to keep a log of how you're tracking.
								</p>
							</li>
						}
					</ul>
				</div>
			</div>   
		)
	}
}

const mapStateToProps = state => {
	return {
		allProgressUpdates: state.account.entities.progress_updates
	}
}

export default connect(mapStateToProps, { 
	openModal,
	getProgressUpdates
})(ProgressUpdate)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-reporting/progress-update.jsx